<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      :offset="offset"
      :immediate-check="ischeck"
      finished-text="没有更多了"
      @load="loadMore"
    >
      <div class="commission-list" v-for="item in dataList" :key="item.RowNumber">
        <div class="hd">
          <div class="left-cnt">
            <div class="btn">赠送会员</div>
            <div class="date">{{item.AddDatetime}}</div>
          </div>
          <!-- <div class="status">交易成功</div> -->
        </div>
        <div class="bd">
          <div class="card-info">
            <div class="card-hd">
              <img :src="item.CoverPhoto" alt class="avatar" />
            </div>
            <div class="card-bd">
              <div class="info-item">
                <span class="label">会员类型：</span>
                <span class="text">{{item.DistributionLevelName}}</span>
              </div>
              <div class="info-item">
                <span class="label">付款金额：</span>
                <span class="text">￥{{item.PayableCoinCount}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="ft">
          <div class="member-info">
            <span class="tit">客户 |</span>
            <span class="name">{{item.NickName}}</span>
            <!-- <span>一级会员</span> -->
          </div>
          <div class="income">
            <span>佣金收益</span>
            <span class="money">￥{{item.Commission}}</span>
          </div>
        </div>
      </div>
    </van-list>
  </van-pull-refresh>
</template>

<script>
export default {
  data() {
    return {
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: []
    };
  },
  props:{
      TypeId:0
  },
  mounted() {
    this.init();
  },
  computed: {},
  methods: {
    init() {
      var that = this;
      that.options = {
        type: "GetDistributionCommissionSeniorList",
        pageIndex: 1,
        TypeId:that.TypeId
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1
      });
      this.getList();
    },
    getList() {
      var that = this;
      var _payStatus = that.PayStatus == undefined ? "" : that.PayStatus;
      //    console.log(_payStatus);
      Object.assign(this.options, {
        PayStatus: _payStatus
      });
      //console.log(this.options);
      that.$store.dispatch(this.options).then(
        res => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          if (res.DistributionCommissionSeniorDetailedList.length <= 0) {
            that.finished = true;
          }
          if (this.options.pageIndex > 1) {
            if (res.DistributionCommissionSeniorDetailedList.length > 0) {
              res.DistributionCommissionSeniorDetailedList.forEach(element => {
                that.dataList.push(element);
              });
            }
          } else {
            that.dataList = res.DistributionCommissionSeniorDetailedList;
          }
        },
        error => {}
      );
    }
  }
};
</script>

<style>
</style>